<template>
  <div
    v-if="!['yektanet-rubika-adv', 'yektanet-sheypoor-adv', 'yektanet-retail-basalam-adv'].includes(getParam('account_custom_type'))"
    id="carouselDesktop"
    class="vertical carousel slide w-100 h-100"
    :style="cssVariables"
    data-bs-ride="carousel"
    data-bs-interval="10000"
  >
    <div
      v-if="getParam('account_custom_type') !== 'yektanet-sms-adv'"
      class="carousel-inner slide-hight"
    >
      <div class="carousel-item active h-100">
        <div class="d-flex align-items-center justify-content-between h-100">
          <div
            class="col-11 col-xl-6 d-flex flex-column align-items-center h-100"
          >
            <div class="w-100 flex-2"></div>
            <div class="info-detail-container my-3">
              <h2 class="info-title">چرا در یکتانت ثبت‌نام کنیم؟</h2>
              <div class="info-button">کیفیت و تنوع نمایش‌دهنده‌ها</div>
              <span class="info-detail">
                یکتانت به کسب‌وکار شما کمک می‌کند تا در بیش از ۲ هزار رسانه
                پربازدید و در بهترین جایگاه‌ها تبلیغ کنید.
              </span>
            </div>
            <div class="signup-arrows flex-4">
              <img
                class="h-100 mr-auto d-block"
                :src="signupBnrs.bnr1.arrowBottom"
              />
            </div>
          </div>
          <div class="col-1 col-xl-6 statue-column">
            <img class="yn-logo" :src="signupBnrs.logo" />
            <img
              class="d-none d-xl-block mt-auto statue-image"
              :src="signupBnrs.bnr1.statue"
            />
          </div>
        </div>
      </div>
      <div class="carousel-item h-100">
        <div class="d-flex align-items-center justify-content-between h-100">
          <div
            class="col-11 col-xl-6 d-flex flex-column align-items-center h-100"
          >
            <div class="signup-arrows">
              <img
                class="h-100 mr-auto d-block"
                :src="signupBnrs.bnr2.arrowTop"
              />
            </div>
            <div class="info-detail-container my-3">
              <h2 class="info-title">چرا در یکتانت ثبت‌نام کنیم؟</h2>
              <div class="info-button">گزارش کامل و دقیق تبلیغات</div>
              <span class="info-detail">
                گزارشی دقیق و با جزئیات کامل برای هر کمپین دریافت کنید؛ تعداد
                کلیک‌، هزینه‌ها، تعداد نمایش، اقدام‌های بعدی کاربران و … کمک
                می‌کند تا تبلیغات را بهینه‌سازی و مدیریت کنید.
              </span>
            </div>
            <div class="signup-arrows">
              <img
                class="h-100 mr-auto d-block"
                :src="signupBnrs.bnr2.arrowBottom"
              />
            </div>
          </div>
          <div class="col-1 col-xl-6 statue-column">
            <img class="yn-logo" :src="signupBnrs.logo" />
            <img
              class="d-none d-xl-block mt-auto statue-image"
              :src="signupBnrs.bnr2.statue"
            />
          </div>
        </div>
      </div>
      <div class="carousel-item h-100">
        <div class="d-flex align-items-center justify-content-between h-100">
          <div
            class="col-11 col-xl-6 d-flex flex-column align-items-center h-100"
          >
            <div class="signup-arrows">
              <img
                class="h-100 mr-auto d-block"
                :src="signupBnrs.bnr3.arrowTop"
              />
            </div>
            <div class="info-detail-container my-3">
              <h2 class="info-title">چرا در یکتانت ثبت‌نام کنیم؟</h2>
              <div class="info-button">پشتیبانی رایگان در تمام مراحل</div>
              <span class="info-detail">
                کارشناسان یکتانت از ثبت‌نام تا ساخت و اجرای تبلیغات در کنار شما
                هستند. با خیال راحت تبلیغ کنید!
              </span>
            </div>
            <div class="signup-arrows">
              <img
                class="h-100 mr-auto d-block"
                :src="signupBnrs.bnr3.arrowBottom"
              />
            </div>
          </div>
          <div class="col-1 col-xl-6 statue-column">
            <img class="yn-logo" :src="signupBnrs.logo" />
            <img
              class="d-none d-xl-block mt-auto statue-image"
              :src="signupBnrs.bnr3.statue"
            />
          </div>
        </div>
      </div>
      <div class="carousel-item h-100">
        <div class="d-flex align-items-center justify-content-between h-100">
          <div
            class="col-11 col-xl-6 d-flex flex-column align-items-center h-100"
          >
            <div class="signup-arrows flex-4">
              <img
                class="h-100 mr-auto d-block"
                :src="signupBnrs.bnr4.arrowTop"
              />
            </div>
            <div class="info-detail-container my-3">
              <h2 class="info-title">چرا در یکتانت ثبت‌نام کنیم؟</h2>
              <div class="info-button">اجرای تبلیغات آسان و سریع</div>
              <span class="info-detail">
                قدم به قدم و در عرض چند دقیقه تبلیغ بسازید تا به سرعت میلیون‌ها
                نفر محصول یا خدمات شما را ببینند.
              </span>
            </div>
            <div class="w-100 flex-2"></div>
          </div>
          <div class="col-1 col-xl-6 statue-column">
            <img class="yn-logo" :src="signupBnrs.logo" />
            <img
              class="d-none d-xl-block mt-auto statue-image"
              :src="signupBnrs.bnr4.statue"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="getParam('account_custom_type') !== 'yektanet-sms-adv'"
      style="left: 25px; top: 50%; transform: translate(-50%) rotate(90deg);"
      class="position-absolute d-flex justify-content-center align-items-center"
    >
      <a href="#carouselDesktop" role="button" data-bs-slide="prev">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9425 19L17 17.9425L13.565 14.5L17 11.0575L15.9425 10L11.4425 14.5L15.9425 19Z"
            fill="#505050"
          />
        </svg>
      </a>
      <ol
        class="carousel-indicators signup-carousel position-relative my-0 mx-2"
      >
        <li
          data-bs-target="#carouselDesktop"
          data-bs-slide-to="0"
          class="active"
        ></li>
        <li data-bs-target="#carouselDesktop" data-bs-slide-to="1"></li>
        <li data-bs-target="#carouselDesktop" data-bs-slide-to="2"></li>
        <li data-bs-target="#carouselDesktop" data-bs-slide-to="3"></li>
      </ol>
      <a href="#carouselDesktop" role="button" data-bs-slide="next">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0575 9L11 10.0575L14.435 13.5L11 16.9425L12.0575 18L16.5575 13.5L12.0575 9Z"
            fill="#505050"
          />
        </svg>
      </a>
    </div>
    <div
      v-if="getParam('account_custom_type') === 'yektanet-sms-adv'"
      class="slide-hight "
    >
      <div class="active h-100">
        <div class="d-flex justify-content-between h-100">
          <div
            class="col-11 col-xl-6 d-flex flex-column align-items-center h-100 ml-3"
          >
            <div
              class="info-detail-container my-6 justify-content-center sms-detail-container"
            >
              <h2 class="info-title">چرا پنل پیامک یکتانت؟</h2>
              <div class="info-button">
                جامع‌ترین بانک مشاغل | به‌روزرسانی فروردین ۱۴۰۳
              </div>
              <div class="trapezoid-sms-panel fanum">
                !فقط 107 تومان
              </div>
              <div class="sms-info-button">
                بدون نیاز به خرید پنل
              </div>
            </div>
          </div>
          <div class="col-1 col-xl-6 statue-column">
            <img class="yn-logo" :src="signupBnrs.logo" />
            <img
              class="d-none d-xl-block mt-auto mb-5 sms-img"
              :src="signupBnrs.sms.statue"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getParam } from "~/utils";

export default {
  data: () => ({ signupBnrs, windowHight: 0 }),
  computed: {
    cssVariables() {
      return { "--height-slide": this.windowHight + "px" };
    },
  },
  mounted() {
    this.observeHeight();
  },
  methods: {
    observeHeight() {
      const resizeObserver = new ResizeObserver(() => {
        this.windowHight = document.body.offsetHeight;
      });

      resizeObserver.observe(document.querySelector("body"));
    },

    getParam,
  },
};
</script>

<style scoped>
.info-detail-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: min-content;
}

.sms-detail-container {
  margin-bottom: 150px;
}

@media (min-width: 1500px) {
  .sms-detail-container {
    margin-right: 40px;
  }
}

.info-title {
  text-align: right;
  font-size: 16px;
  font-weight: 700;
  color: #000;
}

.info-button {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  padding: 8px;
  background: #fad400;
  color: #595959;
  margin-top: 12px;
  border-radius: 8px;
  white-space: nowrap;
}

.sms-info-button {
  transform: rotate(-8.16deg);
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  padding: 8px 20px;
  margin: 0px 70px;
  position: relative;
  bottom: 65px;
  right: 55px;
  background: #fad400;
  color: #595959;
  margin-top: 12px;
  border-radius: 8px;
  white-space: nowrap;
}

.trapezoid-sms-panel {
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  padding: 55px 0px;
  margin: 0px 20px;
  border-top-left-radius: 36px;
  border-bottom-left-radius: 86px;
  border-top-right-radius: 79px;
  background-color: #00948b;
  color: #ffffff;
  clip-path: polygon(
    0 17%,
    94% 17%,
    100% 60%,
    73% 70%,
    74% 94%,
    61% 76%,
    10% 89%
  );
  position: relative;
  left: 30px;
  bottom: 15px;
}

.info-detail {
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  margin-top: 12px;
  direction: rtl;
}

.signup-arrows {
  width: 100%;
  flex: 3;
  padding-left: 80px;
}
@media (max-width: 1200px) {
  .signup-arrows {
    padding-left: 100px;
  }
}

@media (min-width: 1500px) {
  .sms-img {
    height: 70%;
    margin-right: 60px;
  }
}

@media (max-width: 1500px) {
  .sms-img {
    height: 63%;
  }
}

.flex-4 {
  flex: 4 !important;
}
.flex-2 {
  flex: 2 !important;
}

.statue-column {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  height: 100%;
  padding-top: 50px;
  padding-right: 0;
}
@media (min-width: 1500px) {
  .statue-image {
    width: 85%;
  }
}

.yn-logo {
  height: 32px;
  padding-right: 24px;
}

.signup-carousel {
  bottom: unset !important;
}
.signup-carousel li {
  background-color: #fed813;
  opacity: 0.3;
}

.signup-carousel .active {
  opacity: 1 !important;
}

.slide-hight {
  height: var(--height-slide);
}
</style>
<style>
.vertical .carousel-item-next.carousel-item-left,
.vertical .carousel-item-prev.carousel-item-right {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.vertical .carousel-item-next,
.vertical .active.carousel-item-right {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100% 0);
}

.vertical .carousel-item-prev,
.vertical .active.carousel-item-left {
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
</style>
